// Same shape as frontend/src/lib/config.ts but for the admin SPA.
// Resolves the admin BE base URL in priority order:
//   1. localStorage `propwise.admin.api` — dev/QA override.
//   2. import.meta.env.VITE_ADMIN_API_URL  — baked in at build time on
//      Cloudflare Pages from the ADMIN_BE_URL repo var.
//   3. "" (empty) — Vite dev server proxies relative /admin/* to :8082.

const API_KEY = "propwise.admin.api";

export function getApiBase(): string {
  const stored = localStorage.getItem(API_KEY);
  if (stored) return stored.trim().replace(/\/$/, "");
  const built = import.meta.env.VITE_ADMIN_API_URL as string | undefined;
  if (built) return built.trim().replace(/\/$/, "");
  return "";
}

export function setApiBase(url: string): void {
  localStorage.setItem(API_KEY, url.trim());
}

export function resetApiBase(): void {
  localStorage.removeItem(API_KEY);
}
